// HOLDOUTGROUP : holdout-bullshot-26q1

console.log("Init PDM Feature Flags");

// fuction to check holdout group ann add class ab-enabled
const checkHoldout = (_) => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-darwinspets-25q4",
    "OFF",
  );
  if (holdoutGroup != "holdout-darwinspets-26q1") {
    document.documentElement.classList.add("ab-enabled");
    window.ab_enabled = true;
  }
};

// fuction to check holdout group q2 ann add class ab-enabled-q2
const checkHoldoutQ2 = (_) => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );
  if (holdoutGroup !== "holdout-bullshot-26q2") {
    document.documentElement.classList.add("ab-enabled-q2");
    window.ab_enabled_q2 = true;
  }
};

// Feature Flag Key :quick_view_plp
const initQuickViewABTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q1",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q1") return;

  const quickViewEnabled = true;

  if (quickViewEnabled) {
    const quickViewButton = document.querySelectorAll(
      ".product-card__quick-view-btn",
    );
    console.log(quickViewButton, "quickViewButton");
    quickViewButton.forEach((button) => {
      button.classList.add("quick_view_plp_enabled");
    });
  }
};

// Feature Flag Key: see_in_action_pdp
const initSeeInActionABTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q1",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q1") return;

  const seeInActionEnabled = true;

  if (seeInActionEnabled) {
    // Enable See In Action section
    const seeInActionSections = document.querySelectorAll(
      ".section-see-it-in-action",
    );
    seeInActionSections.forEach((section) => {
      section.classList.add("see-in-action_ab_test_enabled");
    });
    // Hide Tabs Widget section
    const tabsWidgetSections = document.querySelectorAll(
      ".section-tabs-widget",
    );
    tabsWidgetSections.forEach((section) => {
      section.style.setProperty("display", "none", "important");
    });
  }
};

// Feature Flag Key :dynamic-imagery-bullshot
const initDynamicImageryTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q1",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q1") return;

  const dynamicImageryEnabled = window._growthbook.getFeatureValue(
    "dynamic-imagery-bullshot",
    true,
  );

  if (dynamicImageryEnabled) {
    const sliderVariants = document.querySelectorAll(
      ".slider-product-card-test",
    );
    sliderVariants.forEach((element) => {
      element.classList.remove("slider-product-card-test");
    });

    const hoverVariants = document.querySelectorAll(".ab-test-variant--hover");
    hoverVariants.forEach((element) => {
      element.classList.add("hover-product-card-test");
    });
  }
};

// Feature Flag Key :free_shipping_callout
const initFreeShippingCallout = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q1",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q1") return;

  const freeShippingCalloutEnabled = true;

  if (freeShippingCalloutEnabled) {
    const freeShippingCallout = document.querySelectorAll(
      ".side-cart__free-shipping-callout",
    );
    freeShippingCallout.forEach((element) => {
      element.classList.add("free-shipping-callout-enabled");
    });
  }
};

// Feature Flag Key :how_it_works_pdp
const initHowItWorksPDP = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q1",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q1") return;

  const howItWorksEnabled = true;

  if (howItWorksEnabled) {
    const howItWorksSections = document.querySelectorAll(
      ".section-how-it-works",
    );
    howItWorksSections.forEach((section) => {
      section.classList.add("how-it-works_ab_test_enabled");
    });
  }
};

// Feature Flag Key: action-button
const initActionButtonTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q1",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q1") return;

  const actionButtonEnabled = true;

  if (actionButtonEnabled) {
    const actionButtons = document.querySelectorAll("[data-see-in-action-btn]");
    actionButtons.forEach((button) => {
      button.classList.add("action-button-test-enabled");
    });

    if (typeof window.validateSeeInActionButton === "function") {
      window.validateSeeInActionButton();
    }
  }
};

// Feature Flag Key: vprops-addressing-concerns-v2
const initVPropsAddressing = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q2") return;

  const vpropsEnabled = window._growthbook.getFeatureValue(
    "vprops-addressing-concerns-v2",
    false,
  );

  if (vpropsEnabled) {
    const vpropsA = document.querySelector(".main-product__claims");
    const vpropsB = document.querySelector(".main-product__claims-tooltip");

    if (!vpropsA || !vpropsB) return;

    vpropsA.classList.add("hidden");
    vpropsB.classList.remove("hidden");
  }
};

// Feature Flag Key: subs-sidecart-v2
// Controls the "Upgrade and Save" widget visibility. The widget is always in
// the DOM with `sidecart-subscription-upgrade--hidden` by default; the test
// variant swaps it for `sidecart-subscription-upgrade--visible`.
const initSubsSidecartV2 = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q2") return;

  const subsSidecartV2Enabled = window._growthbook.getFeatureValue(
    "subs-sidecart-v2",
    false,
  );

  if (subsSidecartV2Enabled) {
    const widgets = document.querySelectorAll(".sidecart-subscription-upgrade");
    widgets.forEach((widget) => {
      widget.classList.remove("sidecart-subscription-upgrade--hidden");
      widget.classList.add("sidecart-subscription-upgrade--visible");
    });
  }
};

// pdm-test-purchase-section was split into three independent flags — each is
// its own control-vs-variant test now instead of one 4-way flag, since B/C/D
// will be run as separate product-level tests rather than one shared rollout.
// The behavior each variant applies is unchanged from before the split.

// Feature Flag Key: pdm-test-purchase-section-b (boolean)
// false = control (no change), true = B (hides the main price)
const initPdmTestPurchaseSectionB = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );
  const inHoldout = holdoutGroup === "holdout-bullshot-26q2";

  const variantBEnabled =
    !inHoldout &&
    window._growthbook?.getFeatureValue("pdm-test-purchase-section-b", false);

  console.log(`[pdm-test-purchase-section-b] enabled: ${variantBEnabled}`);

  // Explicit else branch on purpose: applyFeatureFlags() re-runs on every
  // "growthbookdata" event, so if the flag flips from true back to false
  // (QA toggling it off, holdout reassignment, etc.) the price must be
  // restored — not just left hidden from a previous run.
  document.querySelectorAll("[data-main-price]").forEach((el) => {
    if (variantBEnabled) {
      el.style.setProperty("display", "none", "important");
    } else {
      el.style.removeProperty("display");
    }
  });
};

// applyFeatureFlags() re-runs on every "growthbookdata" event (GrowthBook's
// auto SDK can refire it more than once per pageview), and the C/D init
// functions below run again each time. Each pre-selection only guards
// against re-forcing with a `.checked` check, so if the shopper manually
// reverts their choice and the event fires again, it gets forced right
// back. These flags make each forced pre-selection happen once per page
// load only, so it never fights a selection the shopper already made.
// Kept as two separate flags (not shared) since the B/C/D flags are now
// independent and could in principle both be active for the same visitor.
let pdmPurchaseSectionCForced = false;
let pdmPurchaseSectionDForced = false;

// Feature Flag Key: pdm-test-purchase-section-c (boolean)
// false = control (no change), true = C (pre-selects "One Time Purchase")
const initPdmTestPurchaseSectionC = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q2") return;

  const variantCEnabled = window._growthbook?.getFeatureValue(
    "pdm-test-purchase-section-c",
    false,
  );

  console.log(`[pdm-test-purchase-section-c] enabled: ${variantCEnabled}`);

  if (pdmPurchaseSectionCForced) return;

  if (variantCEnabled) {
    // Pre-select "One Time Purchase" (input#sub_type_2)
    const oneTimeInput = document.getElementById("sub_type_2");
    if (oneTimeInput && !oneTimeInput.checked) {
      oneTimeInput.checked = true;
      oneTimeInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    pdmPurchaseSectionCForced = true;
  }
};

// Feature Flag Key: pdm-test-purchase-section-d (boolean)
// false = control (no change), true = D (pre-selects the "2 Pack" size variant)
const initPdmTestPurchaseSectionD = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q2") return;

  const variantDEnabled = window._growthbook?.getFeatureValue(
    "pdm-test-purchase-section-d",
    false,
  );

  console.log(`[pdm-test-purchase-section-d] enabled: ${variantDEnabled}`);

  if (pdmPurchaseSectionDForced) return;

  if (variantDEnabled) {
    // Pre-select "2 Pack" size variant
    const twoPack = document.querySelector(
      'input[data-option-value="2 Pack"][data-option-position="2"]',
    );
    if (twoPack && !twoPack.checked) {
      twoPack.checked = true;
      twoPack.dispatchEvent(new Event("change", { bubbles: true }));
    }
    pdmPurchaseSectionDForced = true;
  }
};

// Feature Flag Key: pdm-see-in-action
// Type: boolean
// Replaces the legacy standalone "See It In Action" section
// (sections/see-in-action.liquid, class .section-see-it-in-action) with the
// new per-product video carousel embedded in the product info column
// (snippets/product-video-carousel.liquid, wrapped in
// .main-product__video-carousel). The new carousel is hidden by default
// (see src/scss/sections/_product-video-carousel.scss) and only revealed
// when this flag is enabled.
const initPdmSeeInActionTest = () => {
  const holdoutGroup = window._growthbook?.getFeatureValue(
    "holdout-bullshot-26q2",
    "OFF",
  );

  if (holdoutGroup === "holdout-bullshot-26q2") return;

  const pdmSeeInActionEnabled = window._growthbook?.getFeatureValue(
    "pdm-see-in-action",
    false,
  );

  // Explicit else branch on purpose: applyFeatureFlags() re-runs on every
  // "growthbookdata" event, so if the flag flips from true back to false
  // (QA toggling it off, holdout reassignment, etc.) the carousel/legacy
  // section must be restored — not just left in whatever state the last
  // run left them in.
  document
    .querySelectorAll(".main-product__video-carousel")
    .forEach((el) => {
      el.classList.toggle(
        "main-product__video-carousel--ab-test-enabled",
        pdmSeeInActionEnabled,
      );
    });

  document.querySelectorAll(".section-see-it-in-action").forEach((section) => {
    if (pdmSeeInActionEnabled) {
      section.style.setProperty("display", "none", "important");
    } else {
      section.style.removeProperty("display");
    }
  });
};

const initPDMFeatureFlags = () => {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      // Llamadas a feature flags activos se agregan aquí
      initQuickViewABTest();
      initSeeInActionABTest();
      initDynamicImageryTest();
      initHowItWorksPDP();
      initFreeShippingCallout();
      // Runs before initActionButtonTest() so the button's visibility
      // check sees this cycle's section/carousel display state instead of
      // the previous cycle's.
      initPdmSeeInActionTest();
      initActionButtonTest();
      initVPropsAddressing();
      initSubsSidecartV2();
      initPdmTestPurchaseSectionB();
      initPdmTestPurchaseSectionC();
      initPdmTestPurchaseSectionD();
    };

    // check holdout to set ab test
    checkHoldout();
    checkHoldoutQ2();

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener("growthbookdata", (_) => {
      checkHoldout();
      checkHoldoutQ2();
      applyFeatureFlags();
    });
    document.addEventListener("sideCart:refreshed", () => {
      initFreeShippingCallout();
      initSubsSidecartV2();
    });
  });
};

export { initPDMFeatureFlags };
